var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"block uppercase text-blueGray-600 font-bold mb-2",class:_vm.getTextSize,attrs:{"htmlfor":"grid-password"}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }